(function(){
  if(window.yrpFilterPanelBound)return;
  window.yrpFilterPanelBound=true;
  function position(){
    var root=document.getElementById('main-collection-filters');
    if(!root)return;
    var header=document.querySelector('#shopify-section-header .header');
    var banner=document.querySelector('.yrp-banner-header');
    if(banner&&banner.getBoundingClientRect().bottom>0)header=banner;
    var bottom=header?Math.max(0,header.getBoundingClientRect().bottom):0;
    root.style.setProperty('--yrp-filter-top',Math.round(bottom)+'px');
  }
  document.addEventListener('click',function(event){
    var trigger=event.target.closest('#main-collection-filters .mobile-facets__open-wrapper');
    if(!trigger)return;
    position();
    if(!trigger.parentElement.open){
      document.querySelectorAll('.yrp-header-search[open],.yrp-sneaker-mega[open],.yrp-site-nav[open]').forEach(function(menu){menu.open=false;});
      document.body.classList.remove('yrp-nav-open');
    }
  },true);
  document.addEventListener('toggle',function(event){
    if(!event.target.matches('#main-collection-filters .mobile-facets__disclosure'))return;
    position();
    document.body.classList.toggle('yrp-filter-panel-open',event.target.open);
  },true);
  window.addEventListener('resize',position);
})();
